"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _svg4everybody = _interopRequireDefault(require("svg4everybody"));

var _colors = _interopRequireDefault(require("./utils/colors"));

var _sizes = _interopRequireDefault(require("./utils/sizes"));

var _sprites = _interopRequireDefault(require("../assets/sprites.svg"));

require("../css/icon.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

if (typeof window !== 'undefined') {
  (0, _svg4everybody.default)({
    polyfill: true
  });
}

var Icon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Icon, _React$PureComponent);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _getPrototypeOf(Icon).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          className = _this$props.className,
          color = _this$props.color,
          disabled = _this$props.disabled,
          _this$props$display = _this$props.display,
          display = _this$props$display === void 0 ? 'inline-block' : _this$props$display,
          multicolor = _this$props.multicolor,
          name = _this$props.name,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 24 : _this$props$size,
          props = _objectWithoutProperties(_this$props, ["className", "color", "disabled", "display", "multicolor", "name", "size"]);

      var classes = (0, _classnames2.default)((_classnames = {
        'vn-icon': true
      }, _defineProperty(_classnames, "vn-color--".concat(color), !disabled && color !== undefined), _defineProperty(_classnames, "vn-icon--display-".concat(display), true), _defineProperty(_classnames, "vn-icon--size-".concat(size), true), _defineProperty(_classnames, 'vn-icon--disabled', disabled), _defineProperty(_classnames, className, className), _classnames));
      var displayStyle = {
        display: display
      };
      return _react.default.createElement("svg", _extends({
        className: classes,
        fill: multicolor ? 'none' : 'currentColor',
        focusable: false,
        key: name,
        style: displayStyle,
        version: "1.1",
        viewBox: "0 0 32 32"
      }, props), _react.default.createElement("use", {
        xlinkHref: "".concat(_sprites.default, "#").concat(name).concat(multicolor ? '-multicolor' : '')
      }));
    }
  }]);

  return Icon;
}(_react.default.PureComponent);

Icon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(_colors.default),
  disabled: _propTypes.default.bool,
  display: _propTypes.default.oneOf(['block', 'inline-block', 'none']),
  multicolor: _propTypes.default.bool,
  name: _propTypes.default.string.isRequired,
  size: _propTypes.default.oneOf(_sizes.default)
};
Icon.defaultProps = {
  className: undefined,
  color: undefined,
  disabled: false,
  display: 'inline-block',
  multicolor: false,
  size: 24
};
Icon.displayName = 'Icon';
var _default = Icon;
exports.default = _default;